import { LICENCE_CATEGORY, STATION_DETAILS, SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/SCSApplication';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatSCSApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let baseLandFixedStationInfo = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        baseLandFixedStationInfo = licenceDetails?.baseLandFixedStationInfo
            ?.map((value: any) => ({
                'ground-station-name': value?.stationName ?? '-',
                'desired-commencement-date': value?.desiredCommencementDateFormat ?? '-',
                'is-this-a-backup-station': value?.isThisABackupStation ?? '-',
                'please-enter-primary-satellite-communication-station-licence-number': value?.isThisABackupStation ?? '-',
                'location-of-station': value?.locationOfStationEGRooftop ?? '-',
                'building-name': value?.stationAddress?.buildingName ?? '-',
                'postal-code': value?.stationAddress?.postalCode ?? '-',
                'street-name': value?.stationAddress?.streetName ?? '-',
                'block-house-no': value?.stationAddress?.blockNo ?? '-',
                unit: value?.stationAddress?.unit ?? '-',
                'floor-level': value?.stationAddress?.floor ?? '-',
                'is-it-transportable': value?.isItTransportable ?? '-',
                'state-radius-operation-km': value?.operationKmH ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'north-latitude-displacement': value?.northLatitudeDisplacementM ?? '-',
                'east-latitude-displacement': value?.eastLatitudeDisplacementM ?? '-',
                'elevation-above-mean-sea-level': value?.elevationAboveMeanSeaLevelM ?? '-',
                'structure-height': value?.structureHeightM ?? '-',
                'height-of-the-antenna-structure': value?.heightOfTheAntennaStructureMAboveGroundLevel ?? '-',
                'antenna-height-above-ground-level': value?.antennaHeightMAboveGroundLevel ?? '-',
                'lowest-equivalent-satellite-link-noise-temperature': value?.lowestEquivalentSatelliteLinkNoiseTemperatureK ?? '-',
                'receiver-noise-temperature-front-end': value?.receiverNoiseTemperatureFrontEndK ?? '-',
                'receiver-noise-temperature-antenna': value?.receiverNoiseTemperatureAntennaK ?? '-',
                'receiver-noise-temperature-lowest-total-system': value?.receiverNoiseTemperatureLowestTotalSystemK ?? '-',
                'gain-noise-temperature-ratio': value?.gainNoiseTemperatureRatioDBK ?? '-',
                'data-interface': value?.dataInterface ?? '-',
                'encryption-scrambling-standard': value?.encryptionScramblingStandard ?? '-',
                'modulation-scheme': value?.modulationScheme ?? '-',
                'modulation-type': value?.modulationType ?? '-',
                'transmit-type': value?.transmitType ?? '-',
                'receive-type': value?.receiveType ?? '-',
                'transmit-length-in-meters': value?.transmitLengthInMetres ?? '-',
                'receive-length-in-meters': value?.receiveLengthInMetres ?? '-',
                'transmit-path-loss-in-feeder-line': value?.transmitPathLossInFeederLineDB ?? '-',
                'receive-path-loss-in-feeder-line': value?.receivePathLossInFeederLineDB ?? '-',
                'system-emission-power': value?.systemEmissionPowerW ?? '-',
                'system-emission-power-type': value?.systemEmissionPowerTypeWerpOrWeirp ?? '-',
                'transmit-dbw': value?.transmitDBw ?? '-',
                'receive-dbw': value?.receiveDBw ?? '-',
                'transmit-dbwhz': value?.transmitTDBwHz ?? '-',
                'receive-dbwhz': value?.receiveDBwHz ?? '-',
                transmit: value?.transmit ?? '-',
                receive: value?.receive ?? '-',
                'transmit-kbs': value?.transmitKbS ?? '-',
                'receive-kbs': value?.receiveKbS ?? '-',
                'transmit-mbs': value?.transmitMbS ?? '-',
                'receive-mbs': value?.receiveMbS ?? '-',
                'transmit-db': value?.transmitDBAnalog ?? '-',
                'receive-db': value?.receiveDBAnalog ?? '-',
                'transmit-mhz': value?.transmitMHz ?? '-',
                'receive-mhz': value?.receiveMHz ?? '-',
                'transmit-mhz-intermediate': value?.transmitKHzIntermediate ?? '-',
                'receive-mhz-intermediate': value?.receiveKHzIntermediate ?? '-',
                'manufacturer-tx': value?.manufacturerTransmit ?? '-',
                'trade-name-tx': value?.tradeNameTransmit ?? '-',
                'model-tx': value?.modelTransmit ?? '-',
                'minimum-operating-frequency-tx': value?.minimumOperatingFrequencyMHzTransmit ?? '-',
                'maximum-operating-frequency-tx': value?.maximumOperatingFrequencyMHzTransmit ?? '-',
                'intermediate-frequency-3db-bandwidth-tx': value?.intermediateFrequency3DBBandwidthKHzTransmit ?? '-',
                'manufacturer-rx': value?.manufacturerReceive ?? '-',
                'trade-name-rx': value?.tradeNameReceive ?? '-',
                'model-rx': value?.modelReceive ?? '-',
                'minimum-operating-frequency-rx': value?.minimumOperatingFrequencyMHzReceive ?? '-',
                'maximum-operating-frequency-rx': value?.maximumOperatingFrequencyMHzReceive ?? '-',
                'intermediate-frequency-3db-bandwidth-rx': value?.intermediateFrequency3DBBandwidthKHzReceive ?? '-',
                'transmitter-rate-power': value?.transmitterRatePowerWFrequencyStability ?? '-',
                'minimum-acceptable-rx-signed-level': value?.minimumAcceptableRxSignedLevelDBwFrequencyStability ?? '-',
                'transmitter-rate-power-spurious': value?.transmitterRatePowerWSpuriousEmissions ?? '-',
                'minimum-acceptable-rx-signed-level-spurious': value?.minimumAcceptableRxSignedLevelDBwSpuriousEmissions ?? '-',
                'antenna-diameter': value?.antennaDiameterM ?? '-',
                'antenna-manufacturer': value?.manufacturerAntenna ?? '-',
                'antenna-model': value?.modelAntenna ?? '-',
                'antenna-type': value?.antennaType ?? '-',
                'freq-range-transmit-mhz': value?.transmitMHzFrequency ?? '-',
                'freq-range-receive-mhz': value?.receiveMHzFrequency ?? '-',
                'midban-transmit-db': value?.transmitDBMidband ?? '-',
                'midban-receive-db': value?.receiveDBMidband ?? '-',
                'transmit-degree': value?.transmitDegree ?? '-',
                'receive-degree': value?.receiveDegree ?? '-',
                'adjust-range-elevation': value?.adjustRangeElevationDegree ?? '-',
                'adjust-range-azumuth': value?.adjustRangeAzumuthDegree ?? '-',
                'operating-angle-elevation': value?.operatingAngleElevationDegree ?? '-',
                'operating-angle-azimuth': value?.operatingAngleAzimuthDegree ?? '-',
                'operation-kmh': value?.operationKmH ?? '-',
                survival: value?.survival ?? '-',
                'required-information-will-be-attached': value?.requiredInformationWillBeAttachedList ?? '-',
                'filter-manufacturer': value?.manufacturerFilter ?? '-',
                'filter-model': value?.modelFilter ?? '-',
                'rf-filter-type': value?.rfFilterTypeEGBandPassReject ?? '-',
                'isolation-a': value?.isolationADB ?? '-',
                'isolation-b': value?.isolationBDB ?? '-',
                'transmit-from-mhz': value?.transmitFromMHz ?? '-',
                'transmit-to-mhz': value?.transmitToMHz ?? '-',
                'transmit-bandwidth-khz': value?.transmitBandwidthKHz ?? '-',
                'receive-bandwidth-khz': value?.receiveBandwidthKHz ?? '-',
                'receive-from-mhz': value?.receiveFromMHz ?? '-',
                'receive-to-mhz': value?.receiveToMHz ?? '-',
                'minimum-separation-mhz': value?.minimumSeparationMHz ?? '-',
                'tuned-frequency-mhz': value?.tunedFrequencyMHz ?? '-',
                'satellite-frequency-type-list':
                    value?.frequencyAndEmissionClassInformation.map((i: any) => {
                        return {
                            'id-no': i?.rowId,
                            'assigned-frequency-mhz-from-tx': i.assignedFrequencyMHzFromTransmit ?? '-',
                            'assigned-frequency-mhz-to-tx': i.assignedFrequencyMHzToTransmit ?? '-',
                            'assigned-frequency-mhz-from-rx': i.assignedFrequencyMHzFromReceive ?? '-',
                            'assigned-frequency-mhz-to-rx': i.assignedFrequencyMHzToReceive ?? '-',
                            'assigned-bandwidth-khz-tx': i.AssignedBandwidthTx ?? '-',
                            'assigned-bandwidth-khz-rx': i.AssignedBandwidthRx ?? '-',
                            'start-time': i.startTime ?? '-',
                            'stop-time': i.stopTime ?? '-',
                            'satellite-type': i.SatelliteTypeProp ?? '-',
                            'orbital-longitude': i.orbitalLongitude ?? '-',
                            'name-of-satellite-operator': i.nameOfSatelliteOperator ?? '-',
                            'associated-space-station': i.associatedSpaceStation ?? '-',
                            'emission-class-transmit': i?.emissionClassTransmit ?? '-',
                            'emission-class-receive': i?.emissionClassReceive ?? '-',
                            power: i?.Power ?? '-',
                            'power-unit': i?.PowerUnit ?? '-',
                            'frequency-entry-tx': i?.FrequencyEntryTx ?? '-',
                            'frequency-entry-rx': i?.FrequencyEntryRx ?? '-'
                        };
                    }) ?? '-'
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`ground-station-name-${index}`]: item['ground-station-name'],
                    [`desired-commencement-date-${index}`]: item['desired-commencement-date'],
                    [`is-this-a-backup-station-${index}`]: item['is-this-a-backup-station'],
                    [`please-enter-primary-satellite-communication-station-licence-number-${index}`]:
                        item['please-enter-primary-satellite-communication-station-licence-number'],
                    [`location-of-station-${index}`]: item['location-of-station'],
                    [`building-name-${index}`]: item['building-name'],
                    [`postal-code-${index}`]: item['postal-code'],
                    [`street-name-${index}`]: item['street-name'],
                    [`block-house-no-${index}`]: item['block-house-no'],
                    [`unit-${index}`]: item['unit'],
                    [`floor-level-${index}`]: item['floor-level'],
                    [`is-it-transportable-${index}`]: item['is-it-transportable'],
                    [`state-radius-operation-km-${index}`]: item['state-radius-operation-km'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`north-latitude-displacement-${index}`]: item['north-latitude-displacement'],
                    [`east-latitude-displacement-${index}`]: item['east-latitude-displacement'],
                    [`elevation-above-mean-sea-level-${index}`]: item['elevation-above-mean-sea-level'],
                    [`structure-height-${index}`]: item['structure-height'],
                    [`height-of-the-antenna-structure-${index}`]: item['height-of-the-antenna-structure'],
                    [`antenna-height-above-ground-level-${index}`]: item['antenna-height-above-ground-level'],
                    [`lowest-equivalent-satellite-link-noise-temperature-${index}`]:
                        item['lowest-equivalent-satellite-link-noise-temperature'],
                    [`receiver-noise-temperature-front-end-${index}`]: item['receiver-noise-temperature-front-end'],
                    [`receiver-noise-temperature-antenna-${index}`]: item['receiver-noise-temperature-antenna'],
                    [`receiver-noise-temperature-lowest-total-system-${index}`]: item['receiver-noise-temperature-lowest-total-system'],
                    [`gain-noise-temperature-ratio-${index}`]: item['gain-noise-temperature-ratio'],
                    [`data-interface-${index}`]: item['data-interface'],
                    [`encryption-scrambling-standard-${index}`]: item['encryption-scrambling-standard'],
                    [`modulation-scheme-${index}`]: item['modulation-scheme'],
                    [`modulation-type-${index}`]: item['modulation-type'],
                    [`transmit-type-${index}`]: item['transmit-type'],
                    [`receive-type-${index}`]: item['receive-type'],
                    [`transmit-length-in-meters-${index}`]: item['transmit-length-in-meters'],
                    [`receive-length-in-meters-${index}`]: item['receive-length-in-meters'],
                    [`transmit-path-loss-in-feeder-line-${index}`]: item['transmit-path-loss-in-feeder-line'],
                    [`receive-path-loss-in-feeder-line-${index}`]: item['receive-path-loss-in-feeder-line'],
                    [`system-emission-power-${index}`]: item['system-emission-power'],
                    [`system-emission-power-type-${index}`]: item['system-emission-power-type'],
                    [`transmit-dbw-${index}`]: item['transmit-dbw'],
                    [`receive-dbw-${index}`]: item['receive-dbw'],
                    [`transmit-dbwhz-${index}`]: item['transmit-dbwhz'],
                    [`receive-dbwhz-${index}`]: item['receive-dbwhz'],
                    [`transmit-${index}`]: item['transmit'],
                    [`receive-${index}`]: item['receive'],
                    [`transmit-kbs-${index}`]: item['transmit-kbs'],
                    [`receive-kbs-${index}`]: item['receive-kbs'],
                    [`transmit-mbs-${index}`]: item['transmit-kbs'],
                    [`receive-mbs-${index}`]: item['receive-kbs'],
                    [`transmit-db-${index}`]: item['transmit-db'],
                    [`receive-db-${index}`]: item['receive-db'],
                    [`transmit-mhz-${index}`]: item['transmit-mhz'],
                    [`receive-mhz-${index}`]: item['receive-mhz'],
                    [`manufacturer-tx-${index}`]: item['manufacturer-tx'],
                    [`trade-name-tx'-${index}`]: item['trade-name-tx'],
                    [`model-tx-${index}`]: item['model-tx'],
                    [`minimum-operating-frequency-tx-${index}`]: item['minimum-operating-frequency-tx'],
                    [`maximum-operating-frequency-tx-${index}`]: item['maximum-operating-frequency-tx'],
                    [`intermediate-frequency-3db-bandwidth-tx-${index}`]: item['intermediate-frequency-3db-bandwidth-tx'],
                    [`manufacturer-rx-${index}`]: item['manufacturer-rx'],
                    [`trade-name-rx'-${index}`]: item['trade-name-rx'],
                    [`model-rx-${index}`]: item['model-rx'],
                    [`minimum-operating-frequency-rx-${index}`]: item['minimum-operating-frequency-rx'],
                    [`maximum-operating-frequency-rx-${index}`]: item['maximum-operating-frequency-rx'],
                    [`intermediate-frequency-3db-bandwidth-rx-${index}`]: item['intermediate-frequency-3db-bandwidth-rx'],
                    [`transmitter-rate-power-${index}`]: item['transmitter-rate-power'],
                    [`minimum-acceptable-rx-signed-level-${index}`]: item['minimum-acceptable-rx-signed-level'],
                    [`transmitter-rate-power-spurious-${index}`]: item['transmitter-rate-power-spurious'],
                    [`minimum-acceptable-rx-signed-level-spurious-${index}`]: item['minimum-acceptable-rx-signed-level-spurious'],
                    [`antenna-diameter-${index}`]: item['antenna-diameter'],
                    [`antenna-manufacturer-${index}`]: item['antenna-manufacturer'],
                    [`antenna-model-${index}`]: item['antenna-model'],
                    [`antenna-type-${index}`]: item['antenna-type'],
                    [`freq-range-transmit-mhz-${index}`]: item['freq-range-transmit-mhz'],
                    [`freq-range-receive-mhz-${index}`]: item['freq-range-receive-mhz'],
                    [`midban-transmit-db-${index}`]: item['midban-transmit-db'],
                    [`midban-receive-db-${index}`]: item['midban-receive-db'],
                    [`transmit-degree-${index}`]: item['transmit-degree'],
                    [`receive-degree-${index}`]: item['receive-degree'],
                    [`adjust-range-elevation-${index}`]: item['adjust-range-elevation'],
                    [`adjust-range-azumuth-${index}`]: item['adjust-range-azumuth'],
                    [`operating-angle-elevation-${index}`]: item['operating-angle-elevation'],
                    [`operating-angle-azimuth-${index}`]: item['operating-angle-azimuth'],
                    [`operation-kmh-${index}`]: item['operation-kmh'],
                    [`survival-${index}`]: item['survival'],
                    [`required-information-will-be-attached-${index}`]: item['required-information-will-be-attached'],
                    [`filter-manufacturer-${index}`]: item['filter-manufacturer'],
                    [`filter-model-${index}`]: item['filter-model'],
                    [`rf-filter-type-${index}`]: item['rf-filter-type'],
                    [`isolation-a-${index}`]: item['isolation-a'],
                    [`isolation-b-${index}`]: item['isolation-b'],
                    [`transmit-from-mhz-${index}`]: item['transmit-from-mhz'],
                    [`transmit-to-mhz-${index}`]: item['transmit-to-mhz'],
                    [`transmit-bandwidth-khz-${index}`]: item['transmit-bandwidth-khz'],
                    [`receive-bandwidth-khz-${index}`]: item['receive-bandwidth-khz'],
                    [`receive-from-mhz-${index}`]: item['receive-from-mhz'],
                    [`receive-to-mhz-${index}`]: item['receive-to-mhz'],
                    [`minimum-separation-mhz-${index}`]: item['minimum-separation-mhz'],
                    [`tuned-frequency-mhz-${index}`]: item['tuned-frequency-mhz'],
                    [`satellite-frequency-type-list-${index}`]: item['satellite-frequency-type-list']
                };
            });
    }

    licence = {
        id: 'satellite-comm-licence',
        formID: 'satellite-comm-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${LICENCE_CATEGORY}-licence-category`]: licenceDetails?.applicationInformation?.licenceCategory ?? '-',
            [`${LICENCE_CATEGORY}-proposed-use-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '-',
            [`${LICENCE_CATEGORY}-if-others-please-specify`]: licenceDetails?.applicationInformation?.ifOthersPleaseSpecifyReceive ?? '-',
            [`${LICENCE_CATEGORY}-existing-fbo-or-sbo-licence`]: licenceDetails?.applicationInformation?.existingFboOrSboLicence ?? '-',
            [`${LICENCE_CATEGORY}-please-enter-fbo-sbo-licence`]:
                licenceDetails?.applicationInformation?.pleaseEnterFboSboLicenceNumber ?? '-',
            [`${LICENCE_CATEGORY}-existing-tvro-licence`]: licenceDetails?.applicationInformation?.existingTvroLicence ?? '-',
            [`${LICENCE_CATEGORY}-please-enter-tvro-licence`]: licenceDetails?.applicationInformation?.pleaseEnterTvroLicenceNumber ?? '-',
            [`${LICENCE_CATEGORY}-satellite-service`]: licenceDetails?.SatelliteServiceSCS ?? '-',

            [`${STATION_DETAILS}-list`]: baseLandFixedStationInfo ?? [...baseLandFixedStationInfo],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-satellite-comm-licence',
            formID: 'amend-satellite-comm-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_CATEGORY}-amend-table`]: Array.isArray(mapped) && mapped.length > 0 ? [...mapped] : [],
                [`${LICENCE_CATEGORY}-licence-category`]: licenceDetails?.applicationInformation?.licenceCategory ?? '-',
                [`${LICENCE_CATEGORY}-proposed-use-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '-',
                [`${LICENCE_CATEGORY}-if-others-please-specify`]:
                    licenceDetails?.applicationInformation?.ifOthersPleaseSpecifyReceive ?? '-',
                [`${LICENCE_CATEGORY}-existing-fbo-or-sbo-licence`]: licenceDetails?.applicationInformation?.existingFboOrSboLicence ?? '-',
                [`${LICENCE_CATEGORY}-please-enter-fbo-sbo-licence`]:
                    licenceDetails?.applicationInformation?.pleaseEnterFboSboLicenceNumber ?? '-',
                [`${LICENCE_CATEGORY}-existing-tvro-licence`]: licenceDetails?.applicationInformation?.existingTvroLicence ?? '-',
                [`${LICENCE_CATEGORY}-please-enter-tvro-licence`]:
                    licenceDetails?.applicationInformation?.pleaseEnterTvroLicenceNumber ?? '-',
                [`${LICENCE_CATEGORY}-satellite-service`]: licenceDetails?.SatelliteServiceSCS ?? '-',

                [`${STATION_DETAILS}-list`]: baseLandFixedStationInfo ?? [...baseLandFixedStationInfo],

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    return licence;
};

const scsPayloadApplication = {
    formatSCSApplication
};

export default scsPayloadApplication;
